import React, {
    useContext,
    useRef,
    useEffect
} from 'react';
import Cookies from "js-cookie";
import { useNavigate, useLocation, useSearchParams } from "react-router";

import { getCustomer, refetchCustomer, NotificationContext, handleError } from "../router"

import * as QUERIES from "../query-functions";

import LoadingIndicator from '../components/loading-indicator';
import LogoutButton from '../components/logout-button';
import AvatarCircle from "../svg/avatar-circle"

export default function Login() {

    const {notification, setNotification} = useContext(NotificationContext);

    let navigate = useNavigate();

    const { data: customer, isPending, isFetching } = getCustomer();
    const [searchParams, setSearchParams] = useSearchParams();

    const containerRef = useRef(null);
    const redirect_param = searchParams.get("r");
    const location = useLocation();
    // const from = redirect_param ? redirect_param :
    //                 location.state?.from?.pathname ? location.state.from.pathname : "/checkout/";


    useEffect(() => {
        if (!customer) return;        
        
        // Must match structure in SpektrixSession.php
        const session_data = {
            'customer': customer.email,
            'id': customer.id ?? '',
            'email': customer.email ?? '',
            'firstName': customer.firstName ?? '',
            'lastName': customer.lastName ?? '',
            'priority_events': []
        };

        // If the script in the iframe dispatches the update_session event then reset the cookie and update the session
        Cookies.set('spektrix_session', JSON.stringify(session_data), { expires: 1 / 24, path: '/'});

        // If the user is logged in send them to the account area
        navigate(`/account`);

    }, [customer]);

    useEffect(() => {

        const loginFormTemplate = document.getElementById("loginForm");

        if (!loginFormTemplate || !containerRef.current) return;

        const clone = loginFormTemplate.content.cloneNode(true);
        containerRef.current.innerHTML = "";
        containerRef.current.appendChild(clone);

    }, [containerRef.current, customer, isPending, isFetching ]);

    useEffect(() => {
        // This event is dispatched by <spektrix-login>.
        // Capture it here to redirect.
        const handleLoginSuccess = () => {
            // if (from) {
            //     window.location.href = from;
            // } else {
            //     refetchCustomer();
            // }

            refetchCustomer();
        };

        document.addEventListener("loginSuccess", handleLoginSuccess);

        return () => {
            document.removeEventListener("loginSuccess", handleLoginSuccess);
        };
    }, []);


    if (isPending || isFetching || customer) return <LoadingIndicator type="page" />

    return (
        <div className="booking-pathway__container booking-pathway__login">
            <div className='booking-pathway__main-content'>
                <h1 className='booking-pathway__header'><AvatarCircle /> Login</h1>

                <div ref={containerRef} className='booking-pathway__login--form'></div>
            </div>
        </div>
    );
}
